export function filterDuplicateKeys(option, index, self) {
	return index === self.findIndex((p) => p.key === option.key);
}
